import { ClientCreditSummary, type ClientCreditSummaryProps } from '../modules/sales/index.js';
import { useCompanyScope } from './company-context.js';

export function ClientCredit(props: ClientCreditSummaryProps) {
  const { can, company } = useCompanyScope();
  if (!can('sales.read')) return null;
  const businessUnitId = props.businessUnitId ?? company.activeBusinessUnitId ?? undefined;
  const unitName = company.businessUnits?.find((unit) => unit.id === businessUnitId)?.displayName;
  return <ClientCreditSummary {...props} businessUnitId={businessUnitId} unitName={unitName} />;
}
